// ShiftDashboardSkeleton.jsx
import * as React from 'react';
import { Box, Grid, Paper, Skeleton } from '@mui/material';

// Shimmer placeholder for the buttons, the two summary tables and the ticket table
export default function ShiftDashboardSkeleton() {
  const btnHeight = 64;
  const headerHeight = 40; // height of table header skeleton rows
  const rowHeight = 32; // height of each fake data row
  const summaryRows = 8; // CH … Kontobetaling (7–8 lines)
  const ticketRows = 26; // arbitrary for the skeleton

  // Helper to paint one summary-table placeholder
  const SummarySkeleton = () => (
    <Paper sx={{ bgcolor: '#0f1226', p: 0, width: '100%' }}>
      {/* table header */}
      <Skeleton variant="rectangular" height={headerHeight} />
      {/* fake rows */}
      {Array.from({ length: summaryRows }).map((_, i) => (
        <Skeleton
          key={i}
          variant="rectangular"
          height={rowHeight}
          sx={{ mt: 0.5 }}
        />
      ))}
    </Paper>
  );

  // Helper for the ticket list placeholder
  const TicketsSkeleton = () => (
    <Paper sx={{ bgcolor: '#0f1226', p: 0, width: '100%' }}>
      <Skeleton variant="rectangular" height={headerHeight} />
      {Array.from({ length: ticketRows }).map((_, i) => (
        <Skeleton
          key={i}
          variant="rectangular"
          height={rowHeight}
          sx={{ mt: 0.5 }}
        />
      ))}
    </Paper>
  );

  return (
    <Box sx={{ minHeight: '100vh', p: 5 }}>
      <Grid container spacing={4} justifyContent="center">
        {/* ── buttons row ─────────────────────────────────────── */}
        <Grid item xs={12} md={6} lg={4}>
          <Skeleton
            variant="rectangular"
            height={btnHeight}
            sx={{ borderRadius: 1 }}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Skeleton
            variant="rectangular"
            height={btnHeight}
            sx={{ borderRadius: 1 }}
          />
        </Grid>

        {/* ── two summary placeholders ───────────────────────── */}
        <Grid item xs={12} md={6}>
          <SummarySkeleton />
        </Grid>
        <Grid item xs={12} md={6}>
          <SummarySkeleton />
        </Grid>

        {/* ── tickets placeholder ────────────────────────────── */}
        <Grid item xs={12}>
          <TicketsSkeleton />
        </Grid>
      </Grid>
    </Box>
  );
}
